import { api } from '@/lib/api';
import type {
  CommissionRule,
  Coverage,
  ServiceCommissionRule,
  SetRuleInput,
  SetServiceRuleInput,
  Vertical,
} from './types';

/** Every rule with what it is worth, plus every gap. One request for the whole screen. */
export async function fetch_commission_coverage(): Promise<Coverage> {
  const res = await api.get<Coverage>('/admin/commission/coverage');
  return res.data;
}

export async function fetch_commission_rules(vertical?: Vertical): Promise<CommissionRule[]> {
  const res = await api.get<{ items: CommissionRule[] }>('/admin/commission/rules', {
    params: vertical ? { vertical } : {},
  });
  return res.data.items;
}

/** Upsert — one rule per vertical+category, so this replaces rather than adds. */
export async function set_commission_rule(input: SetRuleInput): Promise<CommissionRule> {
  const res = await api.put<CommissionRule>('/admin/commission/rules', input);
  return res.data;
}

export async function fetch_service_commission_rules(): Promise<ServiceCommissionRule[]> {
  const res = await api.get<{ items: ServiceCommissionRule[] }>('/admin/commission/service-rules');
  return res.data.items;
}

export async function set_service_commission_rule(
  input: SetServiceRuleInput,
): Promise<ServiceCommissionRule> {
  const res = await api.put<ServiceCommissionRule>('/admin/commission/service-rules', input);
  return res.data;
}

/** The adopter contact-unlock fee. Not a vendor commission — see the backend service for why. */
export type AdoptionFeeSetting = {
  amount_inr: string;
  updated_at: string | null;
  updated_by_user_id: string | null;
};

export async function fetch_adoption_fee(): Promise<AdoptionFeeSetting> {
  const res = await api.get<AdoptionFeeSetting>('/admin/commission/adoption-fee');
  return res.data;
}

export async function set_adoption_fee(amount_inr: number): Promise<AdoptionFeeSetting> {
  const res = await api.put<AdoptionFeeSetting>('/admin/commission/adoption-fee', { amount_inr });
  return res.data;
}
